
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from "./pages/Index";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import About from "./pages/About";
import Contact from "./pages/NotFound"; // Using NotFound for Contact temporarily
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Apologetics from "./pages/Apologetics";
import BibleTools from "./pages/BibleTools";
import PrayerGenerator from "./pages/PrayerGenerator";
import Ministry from "./pages/Ministry";
import ResetPassword from "./pages/ResetPassword";
import UpdatePassword from "./pages/UpdatePassword";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FindYourVerse from "./pages/FindYourVerse";
import DeepDive from "./pages/DeepDive";
import Etymology from "./pages/Etymology";
import ReadingPlan from "./pages/ReadingPlan";
import ScriptureNavigator from "./pages/ScriptureNavigator";
import DashboardPage from "./pages/Dashboard";
import { PrivateRoute } from "./components/PrivateRoute";
import Profile from "./pages/Profile";
import { Toaster } from "./components/ui/toaster";
import StandaloneAssistant from "./pages/StandaloneAssistant";
import { LiveChatWidget } from "./components/LiveChat/LiveChatWidget";
import MetadataProvider from "./components/MetadataProvider";

function App() {
  return (
    <Router>
      <MetadataProvider>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/apologetics" element={<Apologetics />} />
          <Route path="/bible-tools" element={<BibleTools />} />
          <Route path="/prayer-generator" element={<PrayerGenerator />} />
          <Route path="/ministry" element={<Ministry />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/update-password" element={<UpdatePassword />} />
          
          {/* Scripture Tool Routes */}
          <Route path="/find-your-verse" element={<FindYourVerse />} />
          <Route path="/deep-dive" element={<DeepDive />} />
          <Route path="/etymology" element={<Etymology />} />
          <Route path="/reading-plan" element={<ReadingPlan />} />
          <Route path="/scripture-navigator" element={<ScriptureNavigator />} />
          
          {/* Protected Routes - Only accessible when authenticated */}
          <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/standalone-assistant" element={<StandaloneAssistant />} />
        </Routes>
        <Footer />
        <LiveChatWidget />
        <Toaster />
      </MetadataProvider>
    </Router>
  );
}

export default App;
